import { PortfolioPositionsBalanceCalculationService } from "./PortfolioPositionsBalanceCalculationService";
import { PortfolioPositionsRhoCalculationService } from "./PortfolioPositionsRhoCalculationService";
import { PortfolioPositionsThetaCalculationService } from "./PortfolioPositionsThetaCalculationService";
import { PortfolioPositionsVegaCalculationService } from "./PortfolioPositionsVegaCalculationService";
import { PortfolioPositionsGammaCalculationService } from "./PortfolioPositionsGammaCalculationService";
import { PortfolioPositionsDeltaCalculationService } from "./PortfolioPositionsDeltaCalculationService";

class PortfolioPositionsCalculationService {
    readonly balance: PortfolioPositionsBalanceCalculationService;
    readonly delta: PortfolioPositionsDeltaCalculationService;
    readonly gamma: PortfolioPositionsGammaCalculationService;
    readonly vega: PortfolioPositionsVegaCalculationService;
    readonly theta: PortfolioPositionsThetaCalculationService;
    readonly rho: PortfolioPositionsRhoCalculationService;

    constructor() {
        this.balance = new PortfolioPositionsBalanceCalculationService();
        this.delta = new PortfolioPositionsDeltaCalculationService();
        this.gamma = new PortfolioPositionsGammaCalculationService();
        this.vega = new PortfolioPositionsVegaCalculationService();
        this.theta = new PortfolioPositionsThetaCalculationService();
        this.rho = new PortfolioPositionsRhoCalculationService();
    }
}

export const portfolioPositionsCalculationService = new PortfolioPositionsCalculationService();